export { default as RECORD_STATUSES } from './recordStatuses'

export const CUSTOMER_IDS = {
  CITIZENM: 25,
  TOOLNATION: 15
}

export const JOB_TYPES = [
  'Production',
  'Testing',
  'Development',
  'Alert',
  'Not in use'
]

export const JOB_LOGIC_TYPES = [{
  value: 'P',
  label: 'IPlugin'
}, {
  value: 'L',
  label: 'IJobLogic'
}, {
  value: 'N',
  label: 'Node red'
}, {
  value: 'R',
  label: 'Rest API'
}]

export const RECORD_FILTERS = [{
  value: 'N',
  label: 'None'
}, {
  value: 'D',
  label: 'ID + sysmodified'
}, {
  value: 'H',
  label: 'ID + hash'
}, {
  value: 'F',
  label: 'ID + hash with filtered fields'
}]

export const LOCAL_STORAGE_KEYS = {
  HASH: 'ctx.hash',
  CUSTOMER_LIST: 'ctx.customer-list',
  CUSTOMER: 'ctx.customer',
  RECORDS_PER_PAGE: 'ctx.records.per-page'
}

export const MIME_TYPES = {
  pdf: 'application/pdf',
  html: 'text/html',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  png: 'image/png',
  jpg: 'image/jpg',
  svg: 'image/svg+xml',
  txt: 'text/plain',
  log: 'text/plain'
}

export const DOCUMENT_TYPES = {
  _default: '',
  '': 'T',
  pdf: 'P',
  html: 'H',
  doc: 'W',
  docx: 'W',
  xls: 'E',
  xlsx: 'E',
  png: 'I',
  jpg: 'I',
  jpeg: 'I',
  svg: 'I',
  log: 'T',
  txt: 'T'
}

export const CODEMASH_DB_KEYS = {
  FEEDBACK_ITEMS: 'feedback-items'
}

export const TRANSLATION_MANAGEMENT = {
  FORMATS: {
    JSON: 'Json',
    CSV: 'Csv'
  },

  CSV_SEPARATORS: [{
    value: ',',
    label: ','
  }, {
    value: ' ',
    label: ' (space)'
  }, {
    value: '|',
    label: '|'
  }, {
    value: '-',
    label: '-'
  }]
}
